import * as tpModule from './tp_module';
import * as tpElement from './tp_element';
import * as tpAttrs from './tp_attrs';
import {initJobAttrArray, initNodeAttr} from './tp_attrs';
import selectorShapeArray from './shape/shape.json';


/**
 * 拓扑插件-侧边栏模块、元素定义，用于mock模式
 */


/**
 * 拓扑插件-获取左侧边栏拓扑模块信息mock数据
 * @returns result 数据Promise结果
 */
export function listMockTpModule() {
  return new Promise(resolve => {
    resolve(handleConvertResponseData(tpModule.moduleArray));
  });
}


/**
 * 拓扑插件-根据模块ID获取对应图形类型、元素数据
 * @param moduleId 模块ID
 * @returns result 数据Promise结果
 */
export function listMockTpElementByModuleId(moduleId) {
  return new Promise(resolve => {
    const elementArray = tpElement.elementArray.filter(ele => ele.parentId === moduleId);
    resolve(handleConvertResponseData(elementArray));
  });
}


/**
 * 拓扑插件-获取左侧侧边栏模块、类型和元素数据
 * @returns result 数据Promise结果
 */
export function listMockTpElementData() {
  const moduleArray = [...tpModule.moduleArray];
  moduleArray?.forEach(module => {
    const elementArray = tpElement.elementArray.filter(ele => ele.parentId === module.id);
    module.children = [...elementArray];
  });

  return new Promise(resolve => {
    resolve(handleConvertResponseData(moduleArray));
  });
}


/**
 * 根据图形元素标识获取监视器列表
 * @param params 查询条件
 * @returns promise 监视器列表Promise
 */
export function listMockTpJobByIdentity(params) {
  const attrArray = [...initJobAttrArray(params?.identity)];
  const page = {total: 0, records: []};

  // 关键字匹配
  let filterArray = attrArray;
  const keyWord = params?.keyWord?.trim();
  if (keyWord) {
    filterArray = attrArray.filter(item => item.label.includes(keyWord) || item.ipAddress.includes(keyWord));
  }

  page.records = filterArray?.filter((item, index) => {
    return index < params.pageSize * params.pageNum &&
      index >= params.pageSize * (params.pageNum - 1);
  });

  page.total = filterArray.length;

  return new Promise(resolve => {
    resolve(handleConvertResponseData(page));
  });
}


/**
 * 根据监视器节点ID获取节点扩展信息
 * @param nodeId 节点ID
 * @returns promise 节点扩展信息Promise
 */
export function getMockTopologyNodeExtendInfoById(nodeId) {
  const num = (1000 + Math.round(Math.random() * (999999 - 1000)));
  const nodeExtendInfo = {nodeModel: 'H3C_S' + num, records: []};

  const count = (10 + Math.round(Math.random() * (100 - 10)));
  for (let i = 0; i < count; i++) {
    const ipOne = (2 + Math.round(Math.random() * (255 - 2)));
    const ipTwo = (2 + Math.round(Math.random() * (255 - 2)));
    const port = (80 + Math.round(Math.random() * (9999999 - 80)));
    nodeExtendInfo.records.push({
      idField: i + 1,
      label: '172.16.' + ipOne + '.' + ipTwo + ':' + port,
      portSpeed: (2 + Math.round(Math.random() * (255 - 2)))
    });
  }

  return new Promise(resolve => {
    resolve(handleConvertResponseData(nodeExtendInfo));
  });
}


/**
 * 根据监视器ID获取监视器详情
 * @param jobId 监视器ID
 * @returns promise 监视器详情 Promise
 */
export function listMockJobDetailById(jobId) {
  const ipOne = (2 + Math.round(Math.random() * (255 - 2)));
  const ipTwo = (2 + Math.round(Math.random() * (255 - 2)));
  const detail = [
    {dataLabel: '名称', dataValue: '设备名称'},
    {dataLabel: 'IP', dataValue: '172.16.' + ipOne + '.' + ipTwo},

    {dataLabel: '健康状态', dataValue: '健康'},
    {dataLabel: '可用性', dataValue: '可用'}
  ];

  return new Promise(resolve => {
    resolve(handleConvertResponseData(detail));
  });
}


/**
 * 根据边ID获取连线详情
 * @param edgeId 边ID
 * @returns promise 边详情 Promise
 */
export function listMockLineDetailById(edgeId) {
  const detail = [
    {dataLabel: '上联设备IP', dataValue: '192.168.32.112'},
    {dataLabel: '端口名称', dataValue: 'Gi1/0/1'},

    {dataLabel: '下联设备IP', dataValue: '192.168.32.113'},
    {dataLabel: '端口名称', dataValue: 'Gi1/0/1'},

    {dataLabel: '端口入流量', dataValue: '40G'},
    {dataLabel: '端口出流量', dataValue: '40G'},
    {dataLabel: '端口总流量', dataValue: '40G'},

    {dataLabel: '端口入流速', dataValue: '40Kbps'},
    {dataLabel: '端口出流速', dataValue: '40Kbps'},
    {dataLabel: '端口总流速', dataValue: '40Kbps'},

    {dataLabel: '带宽利用率', dataValue: '3%'},
    {dataLabel: '链路状态', dataValue: '开启'}
  ];

  return new Promise(resolve => {
    resolve(handleConvertResponseData(detail));
  });
}


/**
 * 拓扑插件-根据拓扑ID获取拓扑图所有节点、边和Combo
 * @param tpId 拓扑ID
 * @returns result 拓扑图数据
 */
export function listMockTopologyDataByTpId(tpId) {
  return new Promise(resolve => {
    resolve(handleConvertResponseData({nodes: [], edges: [], combos: []}));
  });
}



/**
 * 拓扑插件-根据元素ID获取图形对应属性
 * @param elementId 元素ID
 * @returns result 数据Promise结果
 */
export function getMockTpShapeAttrById(elementId) {
  return {...tpAttrs?.attrArray?.find(item => item.elementId === elementId)};
}


/**
 * 拓扑插件-初始化-初始化节点属性
 * @param options 扩展参数
 * @returns model 节点model属性
 */
export function initNodeModel(options) {
  return initNodeAttr(options);
}


/**
 * 拓扑插件-获取拓扑选择器组件内置图形数据列表
 */
export function listMockTpShapeList() {
  return new Promise(resolve => {
    resolve(handleConvertResponseData(selectorShapeArray));
  });
}


/**
 * 封装后台数据响应格式
 * @param data 响应数据内容
 * @returns result 请求响应数据
 */
function handleConvertResponseData(data) {
  return {code: '00000', data: data, message: '处理成功'};
}
